import { Component, OnInit } from '@angular/core';
import { MenuService } from 'app/menu/services/menu.service';

@Component({
    template: '',
    standalone: false
})
export class LangComponent implements OnInit {
  /**
   * Selector de idioma
   */
  language = 'ES';
  constructor(
    public menuService: MenuService
  ) {
    this.menuService.language$.subscribe((lang: string) => {
      this.language = lang;
    });

  }

  ngOnInit(): void {
  }


  /**
   * Intercambia los valores del lenguaje seleccionado
   */
  selectLanguage(): void {
    if (this.language === 'ES') {
      this.language = 'EN';
      this.menuService.setLang('EN');
    } else {
      this.menuService.setLang('ES');
      this.language = 'ES';
    }
  }

}
